import { render, staticRenderFns } from "./AdminPrizeElement.vue?vue&type=template&id=6313a81b&scoped=true"
import script from "./AdminPrizeElement.vue?vue&type=script&lang=js"
export * from "./AdminPrizeElement.vue?vue&type=script&lang=js"
import style0 from "./AdminPrizeElement.vue?vue&type=style&index=0&id=6313a81b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6313a81b",
  null
  
)

export default component.exports